import dotenv from "dotenv";
dotenv.config();

const apiUrl = process.env.REACT_APP_NFT_API_URL;

export default apiUrl;
